import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { UserPermission } from '../../types/user';

interface PermissionWrapperProps {
  permission: UserPermission | UserPermission[];
  children: React.ReactNode;
  fallback?: React.ReactNode;
  requireAll?: boolean; // If true, requires ALL permissions, otherwise ANY
}

export const PermissionWrapper: React.FC<PermissionWrapperProps> = ({
  permission,
  children,
  fallback = null,
  requireAll = false,
}) => {
  const { hasPermission } = useAuth();

  const permissions = Array.isArray(permission) ? permission : [permission];

  const hasAccess = requireAll
    ? permissions.every(hasPermission)
    : permissions.some(hasPermission);

  return hasAccess ? <>{children}</> : <>{fallback}</>;
};